import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "权限树", -1)
const _hoisted_3 = { style: {"text-align":"right"} }
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_radio_search = _resolveComponent("miezz-radio-search")!
  const _component_miezz_button = _resolveComponent("miezz-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_power_detail = _resolveComponent("power-detail")!
  const _component_miezz_modal = _resolveComponent("miezz-modal")!
  const _component_power_form = _resolveComponent("power-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, { shadow: "always" }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_miezz_radio_search, {
            radioSearch: _ctx.dto.Scene,
            "onUpdate:radioSearch": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dto.Scene) = $event)),
            radioOptions: _ctx.EnumMenuSceneOption,
            all: false,
            disabledSearch: true,
            prop: "Scene",
            int: true,
            onHandleSearch: _ctx.handleRadioSearch
          }, null, 8, ["radioSearch", "radioOptions", "onHandleSearch"]),
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topButtons, (item, i) => {
              return (_openBlock(), _createBlock(_component_miezz_button, {
                key: i,
                model: item,
                onHandleClick: _ctx.handleTopButtonClick
              }, null, 8, ["model", "onHandleClick"]))
            }), 128))
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_tree, {
          ref: "treeRef",
          "node-key": "Id",
          data: _ctx.models,
          props: _ctx.props,
          "expand-on-click-node": false,
          "default-expand-all": "",
          draggable: "",
          onNodeDrop: _ctx.handleDrop
        }, {
          default: _withCtx(({ data }) => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_tag, {
                class: "node-tag",
                style: _normalizeStyle(data.MarkerColor ? `color: ${data.MarkerColor}` : ''),
                type: "info",
                onClick: ($event: any) => (_ctx.handleNodeClick(data))
              }, {
                default: _withCtx(() => [
                  (data.Remark)
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 0,
                        content: data.Remark,
                        placement: "bottom",
                        effect: "light"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(data.Name), 1)
                        ]),
                        _: 2
                      }, 1032, ["content"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(data.Name), 1))
                ]),
                _: 2
              }, 1032, ["style", "onClick"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.RightItems, (item, i) => {
                return (_openBlock(), _createBlock(_component_el_tag, {
                  key: i,
                  class: "node-tag",
                  style: _normalizeStyle(item.MarkerColor ? `color: ${item.MarkerColor}` : ''),
                  type: "info",
                  onClick: ($event: any) => (_ctx.handleNodeClick(item))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.Name), 1)
                  ]),
                  _: 2
                }, 1032, ["style", "onClick"]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["data", "props", "onNodeDrop"])
      ]),
      _: 1
    }),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalDetail,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modalDetail) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_power_detail, {
          modelValue: _ctx.modalDetail,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modalDetail) = $event)),
          id: _ctx.id,
          onHandleSubmit: _ctx.handleSubmit,
          onHandleDelete: _ctx.handleDelete
        }, null, 8, ["modelValue", "id", "onHandleSubmit", "onHandleDelete"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalForm,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modalForm) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_power_form, {
          modelValue: _ctx.modalForm,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modalForm) = $event)),
          id: _ctx.id,
          path: _ctx.path,
          onHandleSubmit: _ctx.handleSubmit
        }, null, 8, ["modelValue", "id", "path", "onHandleSubmit"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}